export const ACCOUNT_SCOPE_NAMES = {
  full: 'full',
  minimal: 'minimal',
  idNumberAndGroupOnly: 'idNumberAndGroupOnly',
  table: 'table',
};
